export default __webpack_public_path__ + "static/media/260-icon.e64c11c0.svg";